import { render } from "./AlertPop.vue?vue&type=template&id=5b3890e1&scoped=true"
import script from "./AlertPop.vue?vue&type=script&lang=js"
export * from "./AlertPop.vue?vue&type=script&lang=js"

import "./AlertPop.vue?vue&type=style&index=0&id=5b3890e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3890e1"]])

export default __exports__